export default __webpack_public_path__ + "static/media/icon_ikeacn_logo.svg";